import type { KeyboardEvent, MouseEvent } from 'react';

import { IconX } from '../../../common/icons/cdl/X';
import type { ComboBoxOption } from '../types/ComboBoxOption';

import { ValueTagLabel } from './ValueTagLabel';
import { ValueTagRemoveButton } from './ValueTagRemoveButton';
import { ValueTagRoot } from './ValueTagRoot';

interface ValueTagProps<Option extends ComboBoxOption> {
    option: Option;
    onRemove?: (event: KeyboardEvent<HTMLButtonElement> | MouseEvent<HTMLButtonElement>, option: Option) => void;
}

export const ValueTag = <Option extends ComboBoxOption>({ option, onRemove }: ValueTagProps<Option>) => (
    <ValueTagRoot>
        <ValueTagLabel label={option.label} />
        {onRemove ? (
            <ValueTagRemoveButton
                type="button"
                data-testid={`combo-box-remove-${option.value}`}
                tabIndex={-1}
                onClick={(event) => {
                    onRemove(event, option);
                }}
            >
                <IconX width={12} height={12} />
            </ValueTagRemoveButton>
        ) : null}
    </ValueTagRoot>
);
